import React from 'react'

import { Input } from '@cvg/react-components'

import { useFiltersContext } from '@contexts/FilterContext'

const Fcp = () => {
  const { filters, setFilter } = useFiltersContext()

  return (
    <Input
      key={filters.fcpIds}
      type='search'
      placeholder='KE0001'
      label='FCP IDs'
      defaultTerms={filters.fcpIds}
      name='search'
      onSubmit={fcpIds => setFilter({ fcpIds: fcpIds.map(fcpId => fcpId.toUpperCase()) })}
    />
  )
}

export default Fcp
